import { injectable } from "inversify";
import { action, computed, makeObservable, observable } from "mobx";

@injectable()
export class GroupsTabStore {
  private _searchTerm = "";
  showParticipants = false;
  private _filters: Record<string, string[]> = {};
  constructor() {
    makeObservable(this, {
      showParticipants: observable,
      _searchTerm: observable,
      _filters: observable,
      setFilters: action,
      resetSelectedGroup: action,
      setShowParticipants: action,
      setSearchTerm: action,
      filters: computed,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any);
  }

  setFilters(val: Record<string, string[]>) {
    this._filters = val;
  }

  getFilters() {
    return this._filters;
  }

  get filters() {
    return this._filters;
  }

  resetSelectedGroup() {
    this.setFilters({});
    this.setShowParticipants(false);
    this.setSearchTerm("");
  }

  setShowParticipants(val: boolean) {
    this.showParticipants = val;
  }

  get searchTerm() {
    return this._searchTerm;
  }

  setSearchTerm(val: string) {
    this._searchTerm = val;
  }
}
